export default "__VITE_ASSET__BGZ96ioI__"